import { useEffect, useState } from "react"

import { ArrowDownToLineIcon, ArrowLeftToLineIcon, ArrowRightToLineIcon, ArrowUpToLineIcon } from "lucide-react"
import { Select } from "twyne-new.ui"

import { UNIT_OPTIONS } from "../../utils/predefined_sizes"
import { ArbitraryInput } from "../PredefinedArbitraryUnit"

const PositionInputs = ({ values = {}, onChange }) => {
  const [unit, setUnit] = useState()

  const getOldValueUnit = value => {
    const isNegative = value.startsWith('-')
    const oldSplit = value.split('-')
    const newSplit = value.split('_')
    const newUnit = newSplit.length > 1 ? newSplit[1] : isNegative ? null : oldSplit[1]
    return newUnit === 'predefined' || !newUnit ? 'unitless' : newUnit
  }

  useEffect(() => {
    if (unit === undefined) {
      const positionValues = values.bottom || values.left || values.right || values.top || ''
      const newUnit = getOldValueUnit(positionValues)
      setUnit(newUnit)
    }
  }, [unit, values])

  return <>
    <Select
      value={unit}
      onChange={option => setUnit(option?.value)}
      options={[{ value: 'unitless', label: 'Unitless' }, ...UNIT_OPTIONS]}
      variant='accent'
    />
    <div className='grid grid-cols-4 gap-1 items-center'>
      {POSITION_INPUTS.map(item => <InputItem key={item} item={item} unit={unit} value={values[item]} onChange={onChange} />)}
    </div>
  </>
}

const InputItem = ({ item, unit, value, onChange }) => <>
  <div className='col-span-2 w-full'>
    <ArbitraryInput
      value={value}
      onChange={value => onChange({ item, value })}
      addonPrepend={ICONS[item]}
      unit={unit}
    />
  </div>
</>

const POSITION_INPUTS = ['top', 'bottom', 'left', 'right']

const ICONS = {
  top: <ArrowUpToLineIcon size={12} />,
  right: <ArrowRightToLineIcon size={12} />,
  bottom: <ArrowDownToLineIcon size={12} />,
  left: <ArrowLeftToLineIcon size={12} />,
}

export default PositionInputs
